'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitleStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  haveCloseButton: _propTypes2.default.bool,
  paddingSize: _propTypes2.default.oneOf(['none', 'default']),
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  haveCloseButton: false,
  paddingSize: 'default'
};

/** Prop Receivers */
var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme,
      paddingSize = _ref.paddingSize,
      haveCloseButton = _ref.haveCloseButton;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.dialog.title,
      paddingX = _theme$reactackle$com.paddingX,
      paddingY = _theme$reactackle$com.paddingY;


  var paddingXValue = (0, _reactackleCore.getValueString)(paddingX);

  var width = theme.reactackle.components.dialog.closeButton.width,
      py = paddingSize !== 'none' ? '' + (0, _reactackleCore.getValueString)(paddingY) : 0,
      px = paddingSize !== 'none' ? '' + paddingXValue : 0;


  var pxRight = haveCloseButton ? 'calc(' + paddingXValue + ' + ' + (0, _reactackleCore.getValueString)(width) + ')' : '' + paddingXValue;

  return '\n    padding: ' + py + ' ' + pxRight + ' ' + py + ' ' + px + ';\n  ';
};

/** Styles */
var DialogTitleStyled = exports.DialogTitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogTitleStyled'
})(['display:flex;flex-direction:column;flex-shrink:0;flex-grow:1;', ';'], baseProps);

DialogTitleStyled.propTypes = propTypes;
DialogTitleStyled.defaultProps = defaultProps;
DialogTitleStyled.displayName = 'DialogTitleStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/DialogHeading/DialogTitle/styles/DialogTitleStyled.js
// module id = 660
// module chunks = 0